import { formatAddress } from '@finra/rampdi-forms-common';

/**
 * Formats an MU3 address into the two-line HTML block shown on the Main/Mailing Address cards.
 *
 * MU3's address model uses street1/state/country, while the shared formatAddress() reads
 * stateCode/countryCode, so the fields are mapped before formatting. State and country are shown
 * as CODES (e.g. MI, USA), matching MU1/MU4: the country/state lookup lists are intentionally NOT
 * passed, so codes are not resolved to labels.
 *
 * Street lines are merged onto line 1 and city/state/zip/country onto line 2 (single <br>), the
 * MU4 two-line format. Returns an empty string when no address (street1) is present.
 */
export function formatAddressBlock(address: any): string {
  if (!address?.street1) {
    return '';
  }
  const mapped = {
    addressLine1: address.street1,
    addressLine2: address.street2,
    city: address.city,
    stateCode: address.state,
    postalCode: address.postalCode,
    countryCode: address.country,
  };
  return formatAddress(mapped, { mergeAddressLines: true }, false);
}
